import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_GOODS_SAGA } from "../sagaTypes";
import { loaderAction, goodsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getGoodsSagaAction } from "../sagaActions";
import { GOODS_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_goods`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateGoods(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id || '');
        formData.append('name', args.data.name);
        formData.append('cost', args.data.cost);
        formData.append('description', args.data.description);
        formData.append('group', args.data.group);
        formData.append('establishments', args.data.establishments);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список товаров
            yield put(getGoodsSagaAction());
            // Очищаем форму товаров
            yield put(goodsFormAction(GOODS_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateGoods() {
    yield takeLatest(UPDATE_GOODS_SAGA, workerUpdateGoods);
}